export const apiLinks = () => {
    return {
        env: 'production',
        url: 'https://api.apply.credicorp-register.ng/credit-corp-backend-production/api/v1/',
        awsKey: 'production/programmeFiles/',
        applicationLink: 'https://apply.credicorp-register.ng/apply',
        homeLink: 'https://credicorp-register.ng'
    };
}